import { SeverityLevel } from '@microsoft/applicationinsights-web';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import { appInsights } from '../services/ApplicationInsightsService';
import { types } from '../actions/expense';
import { generalEnums } from '../utils/enums';

const initialState = {
  pending: false,
  commentPending: false,
  error: '',
  data: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_PARTICULAR_EXPENSE_PENDING:
      return { ...state, data: null, pending: true, error: '' };
    case types.GET_PARTICULAR_EXPENSE_REJECTED:
      appInsights.trackException({
        error: new Error(action.payload.message),
        severityLevel: SeverityLevel.Error
      });
      return { ...state, pending: false, error: action.payload.message };
    case types.GET_PARTICULAR_EXPENSE_FULFILLED:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...action.payload,
          ExpenseDetails: action.payload.ExpenseDetails.map((item) => ({
            ...item,
            NoReceiptCheck: item?.ExpenseAttachments?.length === 0
          }))
        }
      };
    case types.CREATE_NEW_EXPENSE:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          ExpenseDetails: [
            ...state.data.ExpenseDetails,
            {
              Id: uuidv4(10),
              Type: 'New',
              Date: dayjs().format(generalEnums.DATEFORMAT),
              CategoryId: 1,
              Category: {
                Name: 'Travel'
              },
              ExpenseAmount: 0,
              FxCurrencyId: state.data.ExpenseDetails[0].ExpenseCurrency.Id || null,
              ExpenseCurrencyId: state.data.ExpenseDetails[0].ExpenseCurrency.Id || null,
              ExpenseCurrency: {
                CurrencyName: state.data.ExpenseDetails[0].ExpenseCurrency.CurrencyName || null
              },
              FxCurrency: {
                CurrencyName: state.data.ExpenseDetails[0].ExpenseCurrency.CurrencyName || null
              },
              FxAmount: 1,
              TotalAmount: 0,
              NoReceiptCheck: false,
              Comment: '',
              attachments: [],
              ExpenseAttachments: []
            }
          ]
        }
      };
    case types.UPDATE_EXPENSE_TABLE:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          ExpenseDetails: action.payload.Data.ExpenseDetails
        }
      };
    case types.UPDATE_EXPENSE:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          ExpenseDetails: state.data.ExpenseDetails.map((expense) =>
            expense.Id === action.payload.Data.Id ? action.payload.Data : expense
          )
        }
      };
    case types.CHANGE_EXPENSE_STATUS:
      return { ...state, data: { ...state.data, Status: { ...state.data.Status, Status: action.payload } } };
    case types.CLEAR_EXPENSE_DATA:
      return initialState;
    case types.DELETE_EXPENSE_LINE:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          ExpenseDetails: state.data.ExpenseDetails.filter((expense) => expense.Id !== action.payload.id)
        }
      };
    case types.UPDATE_CLAIM_DATA:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          [action.payload.Data.prop]: action.payload.Data.value
        }
      };
    case types.RESET_NEW_ROW:
      return {
        ...state,
        pending: false,
        error: '',
        data: {
          ...state.data,
          ExpenseDetails: state.data.ExpenseDetails.map((detail) => ({
            ...detail,
            Type: null
          }))
        }
      };
    case types.EXPENSE_SAVE_COMMENT_PENDING:
      return {
        ...state,
        commentPending: true
      };
    case types.EXPENSE_SAVE_COMMENT_REJECTED:
      return {
        ...state,
        commentPending: false
      };
    case types.EXPENSE_SAVE_COMMENT_FULFILLED:
      return {
        ...state,
        commentPending: false,
        data: {
          ...state.data,
          ExpenseRejectionReasons: [
            ...(state.data?.ExpenseRejectionReasons || []),
            {
              ActionTaken: 'Pending',
              Id: action.payload.Id,
              Reason: action.payload.Reason,
              CreatedDate: dayjs().toString(),
              User: {
                FirstName: localStorage.getItem('AirswiftFirstName'),
                LastName: localStorage.getItem('AirswiftLastName')
              }
            }
          ]
        }
      };
    case types.EXPENSE_UPDATE_COMMENT_PENDING:
      return {
        ...state,
        commentPending: true
      };
    case types.EXPENSE_UPDATE_COMMENT_REJECTED:
      return {
        ...state,
        commentPending: false
      };
    case types.EXPENSE_UPDATE_COMMENT_FULFILLED:
      return {
        ...state,
        commentPending: false,
        data: {
          ...state.data,
          ExpenseRejectionReasons: state.data.ExpenseRejectionReasons.map((comment) =>
            comment.Id === action.payload.commentId
              ? { ...comment, Reason: action.payload.comment, CreatedDate: dayjs().toString() }
              : comment
          )
        }
      };
    default:
      return state;
  }
}
